// extracted by mini-css-extract-plugin
module.exports = {"main-background":"FAQ_main-background__i3AUa","static-page":"FAQ_static-page__3YJgG","title":"FAQ_title__2Zwrf","content":"FAQ_content__fil0p","section":"FAQ_section__1fKcr"};